import { useState } from "react";
import { cardsFor, moveAction, kstShort } from "./view";
import { StatusBadge, ChannelBadge } from "./Badges";

// 직원별 업무 보드: GET /inquiries/board 의 칸과 카드. 담당자가 둘이면 두 칸에 모두 보인다.
const colKey = (id) => (id === null ? "none" : String(id));

export default function StaffBoard({ board, meta, team, teams, onTeam, onMove, onOpen }) {
    const [over, setOver] = useState(null);
    const cards = board?.cards || [];
    const handleDrop = (e, toId) => {
        e.preventDefault();
        setOver(null);
        const [cardId, from] = String(e.dataTransfer.getData("text/plain")).split(":");
        const card = cards.find((c) => String(c.id) === cardId);
        if (!card) return;
        const action = moveAction(card, from === "none" ? null : Number(from), toId);
        if (action) onMove(card, action);
    };
    return (
        <div>
            <div className="teams">
                {teams.map((t) => (
                    <button key={t} className={`team ${team === t ? "on" : ""}`} onClick={() => onTeam(t)}>{t}</button>
                ))}
            </div>
            <div className="board">
                {(board?.columns || []).map((c) => {
                    const items = cardsFor(c, cards);
                    return (
                        <div key={colKey(c.id)} data-col={colKey(c.id)} className={`col ${c.id === null ? "col-none" : ""} ${over === colKey(c.id) ? "over" : ""}`}
                            onDragOver={(e) => { e.preventDefault(); setOver(colKey(c.id)); }}
                            onDragLeave={() => setOver(null)}
                            onDrop={(e) => handleDrop(e, c.id)}>
                            <div className="col-h">
                                <span className="ava">{c.id === null ? <i className="fa-solid fa-exclamation"></i> : c.name[0]}</span>
                                <div><b>{c.name}</b><br /><small>{c.id === null ? "배정 필요" : c.team}</small></div>
                                <span className="cnt">{items.length}</span>
                            </div>
                            <div className="col-b">
                                {items.length === 0
                                    ? <div style={{ color: "var(--tx3)", fontSize: 12, textAlign: "center", padding: "14px 0" }}>없음</div>
                                    : items.map((q) => (
                                        <div key={q.id} className="kc" draggable
                                            onDragStart={(e) => { e.dataTransfer.setData("text/plain", `${q.id}:${colKey(c.id)}`); e.dataTransfer.effectAllowed = "move"; }}
                                            onClick={() => onOpen(q.id)}>
                                            <div className="kc-top"><StatusBadge status={q.status} meta={meta} /><ChannelBadge channel={q.channel} />
                                                <span className="t">{kstShort(q.created_at)}{q.is_late && <span className="late">지연</span>}</span></div>
                                            <b>{q.unread && <span className="newdot"></span>}{q.store?.name}</b>
                                            <p><span style={{ color: "var(--tx3)" }}>{q.category?.label} · {q.subcategory?.label}</span> {q.request_content}</p>
                                            {q.schedule?.date && <div className="kc-sch"><i className="fa-regular fa-calendar"></i> 방문 {q.schedule.date.slice(5)} {q.schedule.time || ""}</div>}
                                        </div>
                                    ))}
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="board-hint"><i className="fa-regular fa-hand-pointer"></i> 카드를 다른 직원 칸으로 끌어다 놓으면 담당자가 바뀝니다. 완료·취소 건은 보드에서 빠집니다.</div>
        </div>
    );
}
